<template>
	<div class="store-info-body">
		<div class="store-info-container">
			<div class="info-box">
				<span class="info-title">公告状态：</span>
				<div style="margin-top: 5px;">
					<el-radio v-model="radio" :label="true">开启</el-radio>
					<el-radio v-model="radio" :label="false">停用</el-radio>
				</div>
			</div>
			<div style="text-align:left;">
				<div class="info-title2">文字公告</div>
				<el-input type="textarea" size='mini' v-model="noticeValue" :rows='10' :maxlength='1000' placeholder='请输入店铺公告内容' class="info-textarea"></el-input>
			</div>
		</div>
		<div class="store-info-btn">
			<el-button class="btn" size='small' plain type="primary" @click="cancel">取消</el-button>
			<el-button class="btn" size='small' type="primary" @click="saveInfo">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'shopNotice',
	components: {
	},
	data () {
		return {
			radio: true,
			noticeValue: '',
			shopid: ''
		}
	},
	created () {
	},
	mounted () {
		this.shopid = sessionStorage.getItem('storeid')
		this.getNotice()
	},
	methods: {
		getNotice () {
			let data = {
				shopid: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/shopNotice/get`,
				data: data
			}).then(res => {
				if (res.result) {
					this.radio = res.data === null ? true : res.data.disabledflag
					this.noticeValue = res.data === null ? '' : res.data.memo
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			this.$router.push(`/main/storeBasicInfo`)
		},
		saveInfo () {
			if (this.noticeValue === '') {
				this.$message.error('请输入店铺公告')
				return false
			}
			let that = this
			let data = {
				shopid: this.shopid,
				memo: this.noticeValue,
				disabledflag: this.radio
			}
			that.$store.dispatch('requestPost', {
				url: `${that.$fxBaseApi.urlQIVShop}/shopNotice/save`,
				data: data
			}).then(res => {
				if (res.result) {
					this.getNotice()
					that.$message.success(res.msg)
				} else {
					that.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-info-body {
	display flex;
	height: 100%;
	min-height: 0;
	flex: 1;
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.store-info-container {
		display flex;
		flex: 1;
		overflow-y: auto;
		flex-direction column;
		.form-box {
			display flex
			flex-direction column
			text-align left
			.short-input {
				width: 200px
			}
			.btn-reset {
				margin-left: 20px;
				width: 80px;
			}
		}
	}
	.info-box {
		text-align: left
		display: flex
		align-items: center
		padding-left: 14px
		margin-top: 20px
		margin-bottom: 20px
	}
	.info-title {
		margin-right: 10px;
	}
	.info-title2 {
		text-align: left;
		margin-left: 14px;
	}
	.info-textarea {
		width: 500px;
		margin: 20px;
		margin-left: 50px;
	}
	.store-info-btn {
		box-sizing: border-box;
		height:80px;
		text-align left
		padding: 20px 0
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}
</style>
